import { Component } from '@angular/core';

@Component({
  selector: 'app-share-all-icon',
  templateUrl: './share-all-icon.component.html',
  styleUrl: './share-all-icon.component.scss',
})
export class ShareAllIconComponent {}
